// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_buyerNeed_broadcasts_edges_node_activityReport(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ActivityReportV5"]);
}

function unwrap_fragment_buyerNeed_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ActiveBuyerNeed",
              "ExpiredBuyerNeed",
              "InContractBuyerNeed",
              "PurchasedBuyerNeed",
              "WithdrawnBuyerNeed"
            ]);
}

var fragmentConverter = {"__root":{"buyerNeed_status":{"u":"fragment_buyerNeed_status"},"buyerNeed_broadcasts_edges_node_activityReport":{"u":"fragment_buyerNeed_broadcasts_edges_node_activityReport"},"":{"f":""}}};

var fragmentConverterMap = {
  fragment_buyerNeed_broadcasts_edges_node_activityReport: unwrap_fragment_buyerNeed_broadcasts_edges_node_activityReport,
  fragment_buyerNeed_status: unwrap_fragment_buyerNeed_status
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function buyerNeedMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST" || $$enum === "QUIET") {
    return $$enum;
  }
  
}

function buyerNeedMatchingType_fromString(str) {
  return buyerNeedMatchingType_decode(str);
}

var Utils = {
  buyerNeedMatchingType_decode: buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: buyerNeedMatchingType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetBuyer_Menu_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "BuyerNeedV5",
        "kind": "LinkedField",
        "name": "buyerNeed",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "buyerNeedMatchingType",
              "args": null,
              "kind": "ScalarField",
              "name": "matchingType",
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRenewable",
                      "storageKey": null
                    }
                  ],
                  "type": "ActiveBuyerNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "ExpiredBuyerNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "InContractBuyerNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "PurchasedBuyerNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "WithdrawnBuyerNeed",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "dismissalState",
                "value": "UNDISMISSED"
              }
            ],
            "concreteType": "BuyerNeedMatchConnection",
            "kind": "LinkedField",
            "name": "matches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "BuyerNeedBroadcastConnection",
            "kind": "LinkedField",
            "name": "broadcasts",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "BuyerNeedBroadcastEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedBroadcast",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "activityReport",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v2/*: any*/),
                                  "type": "ActivityReportV5",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            "action": "NONE"
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": "broadcasts(first:1)"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetDeleteDialog_clientV5"
    }
  ],
  "type": "Buyer",
  "abstractKey": null
};
})());

var wrap_fragment_buyerNeed_broadcasts_edges_node_activityReport = RescriptRelay_Internal.wrapUnion;

var wrap_fragment_buyerNeed_status = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_buyerNeed_broadcasts_edges_node_activityReport = unwrap_fragment_buyerNeed_broadcasts_edges_node_activityReport;
exports.wrap_fragment_buyerNeed_broadcasts_edges_node_activityReport = wrap_fragment_buyerNeed_broadcasts_edges_node_activityReport;
exports.unwrap_fragment_buyerNeed_status = unwrap_fragment_buyerNeed_status;
exports.wrap_fragment_buyerNeed_status = wrap_fragment_buyerNeed_status;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
